import React, { useState } from "react";
import { Col, Row, Space, Image } from "antd";
import { MdArrowForwardIos } from "react-icons/md";
import { Link } from "react-router-dom";
import { url } from "../../constants/navhome";
import { AiOutlineMail } from "react-icons/ai";
import { BiPhoneCall } from "react-icons/bi";
import { ImLinkedin } from "react-icons/im";
import { ImInstagram } from "react-icons/im";
import { ImFacebook2 } from "react-icons/im";
import { ImTwitter } from "react-icons/im";
import { ImYoutube } from "react-icons/im";
import { Layout } from "antd";

const { Footer: AntFooter } = Layout;

const Footer = () => {
  const [activeCertificate, setActiveCertificate] = useState(null);

  return (
    <>
      {/* <section className="upper_foot">
        <div className="upper_footer bg">
          <div className="container">
            <Row justify="start" className="mt-5">
              <Col
                xxl={8}
                lg={8}
                md={8}
                sm={24}
                xs={24}
                className="mb-5 is-flex is-justify-content-center"
              >
                <div className="call_us">
                  <div className="call_img">
                    <MdLocationOn className="has-text-white icon color" />
                  </div>
                  <div className="call_text">
                    <h4>AHMEDABAD</h4>
                    <h6>169 Kms( approx)</h6>
                  </div>
                </div>
              </Col>
              <Col
                xxl={8}
                lg={8}
                md={8}
                sm={24}
                xs={24}
                className="mb-5 is-flex is-justify-content-center"
              >
                <div className="call_us">
                  <div className="call_img">
                    <MdLocationOn className="icon has-text-white" />
                  </div>
                  <div className="call_text">
                    <h4>
                      <a
                        href="mailto:rajmahaldevgadhbaria@gmail.com"
                        className="has-text-white"
                      >
                        VADODARA
                      </a>
                    </h4>
                    <h6>103 Kms (approx)</h6>
                  </div>
                </div>
              </Col>
              <Col
                xxl={8}
                lg={8}
                md={8}
                sm={24}
                xs={24}
                className="mb-5 is-flex is-justify-content-center"
              >
                <div className="call_us">
                  <div className="call_img">
                    <MdLocationOn className="icon has-text-white" />
                  </div>
                  <div className="call_text">
                    <h4>SURAT</h4>
                    <h6>169 Kms (approx)</h6>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </section> */}
      {/* <section className="mobile_margin">
        <div className="section_padding"></div>
        <div className="container">
          <div>
            <Slider {...settings}>
              {clientlist.map((item, key) => {
                return (
                  <div>
                    <img src={item.src} alt="404 - Not Given" />
                  </div>
                );
              })}
            </Slider>
          </div>
        </div>
        <div className="section_padding"></div>
      </section> */}
      <AntFooter className="main_footer">
        {/* <div className="section_padding"></div> */}
        <div className="container">
          <Row style={{ display: "flex", justifyContent: "center" }}>
            <Col xxl={8} lg={12} md={12} sm={24} xs={24}>
              <div className="first_col">
                <div className="footer_line">
                  <h3 className="is-size-5 has-text-weight-semibold pb-4 mt-3 has-text-white footer_heading">
                    Quick Links
                  </h3>
                </div>
                <div>
                  <Row className="mt-5">
                    <Col xxl={12} lg={12} md={12} sm={24} xs={24}>
                      <ul className="quick_link">
                        <li className="footer_link">
                          <Link to={url.home} className="has-text-white">
                            <MdArrowForwardIos className="arrow_icon " />
                            <span className="pl-2">Home</span>
                          </Link>
                        </li>
                        <li className="footer_link">
                          <Link to={url.whoweare} className="has-text-white">
                            <MdArrowForwardIos className="arrow_icon " />
                            <span className="pl-2">About Us</span>
                          </Link>
                        </li>
                        {/* <li className="footer_link">
                          <Link to={url.expertise} className="has-text-white">
                            <MdArrowForwardIos className="arrow_icon " />
                            <span className="pl-2">Expertise</span>
                          </Link>
                        </li> */}
                        <li className="footer_link">
                          <Link to={url.services} className="has-text-white">
                            <MdArrowForwardIos className="arrow_icon " />
                            <span className="pl-2">Services</span>
                          </Link>
                        </li>
                        <li className="footer_link">
                          <Link to={url.careers} className="has-text-white">
                            <MdArrowForwardIos className="arrow_icon " />
                            <span className="pl-2">Careers</span>
                          </Link>
                        </li>
                        <li className="footer_link">
                          <Link to={url.Contact} className="has-text-white">
                            <MdArrowForwardIos className="arrow_icon " />
                            <span className="pl-2">Contact Us</span>
                          </Link>
                        </li>
                      </ul>
                    </Col>
                    <Col xxl={12} lg={12} md={12} sm={24} xs={24}>
                      <ul className="quick_link">
                        <li className="footer_link">
                          <Link to={url.investorsInformation} className="has-text-white">
                            <MdArrowForwardIos className="arrow_icon" />
                            <span className="pl-2">Investor's Information</span>
                          </Link>
                        </li>
                        <li className="footer_link">
                          <Link to={url.residential} className="has-text-white">
                            <MdArrowForwardIos className="arrow_icon " />
                            <span className="pl-2">Residential</span>
                          </Link>
                        </li>
                        <li className="footer_link">
                          <Link to={url.commercial} className="has-text-white">
                            <MdArrowForwardIos className="arrow_icon " />
                            <span className="pl-2">Commercial</span>
                          </Link>
                        </li>
                        <li className="footer_link">
                          <Link to={url.industrial} className="has-text-white">
                            <MdArrowForwardIos className="arrow_icon " />
                            <span className="pl-2">Industrial</span>
                          </Link>
                        </li>
                        <li className="footer_link">
                          <Link
                            to={url.institutionalprojects}
                            className="has-text-white"
                          >
                            <MdArrowForwardIos className="arrow_icon " />
                            <span className="pl-2">
                              Institutional & Corporate
                            </span>
                          </Link>
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
            <Col
              xxl={8}
              lg={12}
              md={12}
              sm={24}
              xs={24}
              className="footer_colum"
            >
              <div className="second_col" style={{ marginLeft: "0px" }}>
                <div className="footer_line">
                  <h3 className="is-size-5 has-text-weight-semibold pb-4 mt-3 has-text-white footer_heading">
                    Address
                  </h3>
                </div>
                <div className="footer_address mt-5">
                  <a
                    href="https://www.google.com/maps/place/Hitech+Projects+Private+Limited/@22.9975806,72.4969546,17z/data=!3m1!4b1!4m5!3m4!1s0x395e9b475ef7e48d:0x922a96c8de37de3a!8m2!3d22.9975739!4d72.4991428"
                    target="_blank"
                    rel="noreferrer"
                    className="has-text-white contact_content"
                  >
                    <p className="my-auto">Hitech Projects Limited.</p>
                    <p className="mt-2">A-1401, Block-A, </p>
                    <p>West Gate Business Bay,</p>
                    <p>Besides Signature - 1, S.G. Highway,</p>
                    <p> Makarba, Ahmedabad - 380051. </p>
                    <p>Gujarat, India</p>
                    
                    <p className="mt-3">
                      Regional Office : 
                    </p>
                    <p>
                      401-402, Universal Trade center,
                    </p>
                    <p>
                      L P Savani Road, Adajan, 
                    </p>
                    <p>
                      Surat - 395009
                    </p>
                  </a>
                </div>
              </div>
            </Col>
            {/* <Col
              xxl={8}
              lg={8}
              md={12}
              sm={24}
              xs={24}
              className="footer_colum"
            >
              <div className="third_col">
                <div className="footer_line">
                  <p className="is-size-5 has-text-weight-semibold pb-4 mt-3 has-text-white footer_heading">
                    CONTACT US
                  </p>
                </div>
                <div className="mt-5">
                  <div>
                    <ul>
                      <li className="footer_link">
                        <Space direction="horizontal">
                          <BiPhoneCall className="arrow_icon is-size-4" />
                          <div>
                            <a
                              href="tel:+91 9904592200"
                              className="has-text-white"
                            >
                              <span className="pl-2">+91-9904592200 /</span>
                            </a>
                            <a
                              href="tel:+91 9904288900"
                              className="has-text-white"
                            >
                              <span className="pl-2">+91-9904288900</span>
                            </a>
                          </div>
                        </Space>
                      </li>
                      <li className="footer_link">
                        <Space direction="horizontal">
                          <AiOutlineMail className="arrow_icon is-size-4" />
                          <a
                            href="mailto:info@hitechprojects.co.in"
                            className="has-text-white"
                          >
                            <span className="pl-2">
                              info@hitechprojects.co.in
                            </span>
                          </a>
                        </Space>
                      </li>
                    </ul>
                  </div>
                  <div className="social_icon">
                    <a
                      className="has-text-white"
                      href="https://www.linkedin.com/company/hitechprojects/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <ImLinkedin className="is-size-4" />
                    </a>
                    <a
                      className="has-text-white"
                      href="https://www.instagram.com/hitechpplofficial/"
                      target="blank"
                    >
                      <ImInstagram className="is-size-4 ml-3" />
                    </a>
                    <a
                      className="has-text-white"
                      href="https://www.facebook.com/hitechpplofficial/"
                      target="blank"
                    >
                      <ImFacebook2 className="is-size-4 ml-3" />
                    </a>
                    <a
                      className="has-text-white"
                      href="https://twitter.com/hitechppl"
                      target="blank"
                    >
                      <ImTwitter className="is-size-4 ml-3" />
                    </a>
                    <a
                      className="has-text-white"
                      href="https://www.youtube.com/channel/UCbrjSl-jZB23ZB8HzSNqa8w"
                      target="blank"
                    >
                      <ImYoutube className="is-size-4 ml-3" />
                    </a>
                  </div>
                </div>
              </div>
            </Col> */}
            {/* <Col xxl={6} lg={6} md={12} sm={24} xs={24}>
              <iframe
                title="Maps"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7361.401796299187!2d73.91102953488769!3d22.702175800000006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3960f235596915db%3A0xb11801dc88fd7f55!2sDevgadh%20Baria%2C%20Gujarat%20389380!5e0!3m2!1sen!2sin!4v1661860686358!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </Col> */}
          </Row>
        </div>
        <div className="container">
          <Row style={{ display: "flex", justifyContent: "center" }}>
            <Col xxl={8} lg={12} md={12} sm={24} xs={24}>
              <div className="third_col">
                <div className="footer_line">
                  <p className="is-size-5 has-text-weight-semibold pb-4 mt-3 has-text-white footer_heading">
                    Certifications
                  </p>
                </div>
                <div className="footer_address mt-5">
                  <p className="mt-2">
                    <button
                      type="button"
                      onClick={() => setActiveCertificate("iso9001")}
                      style={{
                        background: "none",
                        border: "none",
                        color: "inherit",
                        cursor: "pointer",
                        padding: 0,
                        font: "inherit",
                        textDecoration: "none",
                      }}
                    >
                      ISO 9001
                    </button>
                  </p>
                  <p>
                    <button
                      type="button"
                      onClick={() => setActiveCertificate("iso45001")}
                      style={{
                        background: "none",
                        border: "none",
                        color: "inherit",
                        cursor: "pointer",
                        padding: 0,
                        font: "inherit",
                        textDecoration: "none",
                      }}
                    >
                      ISO 45001
                    </button>
                  </p>
                </div>
              </div>
            </Col>
            <Col
              xxl={8}
              lg={12}
              md={12}
              sm={24}
              xs={24}
              className="footer_colum"
            >
              <div className="second-col" style={{ marginTop: "0px" }}>
                <div className="footer_line">
                  <h3 className="is-size-5 has-text-weight-semibold pb-4 mt-3 has-text-white footer_heading">
                    Contact Us
                  </h3>
                </div>
                <div className="mt-5">
                  <div>
                    <ul>
                      <li className="footer_link">
                        <Space direction="horizontal">
                          <BiPhoneCall className="arrow_icon is-size-4" />
                          <div>
                            <a
                              href="tel:+91 9904592200"
                              className="has-text-white"
                            >
                              <span className="pl-2">+91-9904592200 /</span>
                            </a>

                            <a
                              href="tel:+91 9904288900"
                              className="has-text-white"
                            >
                              <span className="pl-2">+91-9904288900</span>
                            </a>
                          </div>
                        </Space>
                      </li>
                      <li className="footer_link mb-4">
                        <Space direction="horizontal" align="start">
                          <AiOutlineMail className="arrow_icon is-size-4 mt-1" />
                          <div>
                            <p className="mb-0 has-text-white-ter is-size-7">
                              General Enquiries
                            </p>
                            <a
                              href="mailto:info@hitechprojects.co.in"
                              className="has-text-white"
                            >
                              <span>info@hitechprojects.co.in</span>
                            </a>
                          </div>
                        </Space>
                      </li>
                      <li className="footer_link">
                        <Space direction="horizontal" align="start">
                          <AiOutlineMail className="arrow_icon is-size-4 mt-1" />
                          <div>
                            <p className="mb-0 has-text-white-ter is-size-7">
                              Tender Enquiries
                            </p>
                            <a
                              href="mailto:tender@hitechprojects.co.in"
                              className="has-text-white"
                            >
                              <span>tender@hitechprojects.co.in</span>
                            </a>
                          </div>
                        </Space>
                      </li>
                    </ul>
                    
                  </div>
                  <div className="social_icon">
                    <a
                      className="has-text-white"
                      href="https://www.linkedin.com/company/hitechprojects/"
                      target="blank"
                    >
                      <ImLinkedin className="is-size-4" />
                    </a>
                    <a
                      className="has-text-white"
                      href="https://www.instagram.com/hitechprojects_ltd"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <ImInstagram className="is-size-4 ml-3" />
                    </a>
                    <a
                      className="has-text-white"
                      href="https://www.facebook.com/hitechpplofficial/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <ImFacebook2 className="is-size-4 ml-3" />
                    </a>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        {/* <div className="section_padding"></div> */}
      </AntFooter>
      <hr className="footerhr" />
      <section className="lower_foot bluebg_color">
        <div className="lower_footer">
          <div className="container py-4">
            <p className="is-size-6 has-text-white lower_text has-text-centered">
              Copyright &copy; {new Date().getFullYear()}&nbsp;
              Hitech Projects Limited.&nbsp;
              All rights reserved.
            </p>
          </div>
        </div>
      </section>

      <Image
        style={{ display: "none" }}
        src="Sources/images/awards/39.jpg"
        preview={{
          visible: activeCertificate === "iso9001",
          onVisibleChange: (visible) => {
            if (!visible) setActiveCertificate(null);
          },
          getContainer: "#root",
        }}
      />
      <Image
        style={{ display: "none" }}
        src="Sources/images/awards/38.jpg"
        preview={{
          visible: activeCertificate === "iso45001",
          onVisibleChange: (visible) => {
            if (!visible) setActiveCertificate(null);
          },
          getContainer: "#root",
        }}
      />
    </>
  );
};
export default Footer;
